
<template>
  <div class="image-box">
    <m-img
      :src="img"
      :alt="alt"
      class="img-cov"
        
    />
    <div class="centered">
        
        <slot name="p-1" />
    </div>
  </div>
</template>

<script>
export default {
  name: "C11",
  props: {
    img: {
      default: "",
    },
    alt: {
      default: "mixitweb.com",
    },
  },
};
</script>

<style scoped>
/* container-n holding the image and the text */

.image-box {
  position: relative;
  margin: auto;
  overflow: hidden;
  width:100%;
  text-align: center;
  color: white;
}
.image-box img {
  max-width: 100%;
  transition: all 0.3s;
  display: block;
  width: 100%;
  height: 400px;
  transform: scale(1);
  object-fit: cover;
  filter: brightness(50%);
}

.image-box:hover img {
  transform: scale(1.1);
  filter: blur(0.2rem) brightness(50%);
}



.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>